// extracted by mini-css-extract-plugin
export default {"gift_cards_delivery":"GiftCardsDelivery_gift_cards_delivery__MjTRI","set_date":"GiftCardsDelivery_set_date__+ltdR","submit_error":"GiftCardsDelivery_submit_error__8NIN3"};